var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.455a.73.73 0 0 1 .212-.515c.158-.16.443-.35.874-.524C7.238 4.153 8.074 4 9.11 4c1.023 0 1.72.2 3.157.78 1.272.512 1.838.675 2.62.675.86 0 1.513-.12 1.99-.312.246-.1.367-.18.39-.203.454-.458 1.232-.133 1.232.515v8.727a.73.73 0 0 1-.212.514c-.158.16-.443.351-.874.525-.652.262-1.488.415-2.525.415-1.023 0-1.72-.2-3.157-.779-1.272-.512-1.838-.675-2.62-.675-.86 0-1.513.12-1.99.311-.069.028-.128.055-.178.079v4.7a.725.725 0 0 1-.722.728.725.725 0 0 1-.722-.727V5.455zm3.611 0c-.858 0-1.512.12-1.989.311a2.946 2.946 0 0 0-.178.078v7.172c.592-.184 1.31-.289 2.167-.289 1.023 0 1.72.201 3.157.78 1.272.512 1.838.675 2.62.675.86 0 1.513-.12 1.99-.312.069-.028.128-.054.178-.078V6.621c-.592.184-1.31.288-2.167.288-1.023 0-1.72-.2-3.157-.78-1.272-.512-1.838-.674-2.62-.674z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.edeb6a1b.svg";
export { ForwardRef as ReactComponent };